var _rect, _rect2, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 3.33334,
    width: 16.6667,
    height: 12.5,
    rx: 2,
    fill: "#F9B42A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1125_3415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 18,
    height: 13
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 3.33334,
    width: 16.6667,
    height: 12.5,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1125_3415)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.2778,
    y: 2.17328,
    width: 11.0607,
    height: 22.2754,
    transform: "rotate(50.9737 18.2778 2.17328)",
    fill: "#5A5A5A",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1897 2.5H2.81062C2.28644 2.50059 1.78389 2.70626 1.41324 3.07189C1.04259 3.43753 0.834091 3.93327 0.833496 4.45035V14.3794C0.834091 14.8965 1.04259 15.3923 1.41324 15.7579C1.78389 16.1235 2.28644 16.3292 2.81062 16.3298H17.1897C17.7139 16.3292 18.2164 16.1235 18.5871 15.7579C18.9577 15.3923 19.1662 14.8965 19.1668 14.3794V4.45035C19.1662 3.93327 18.9577 3.43753 18.5871 3.07189C18.2164 2.70626 17.7139 2.50059 17.1897 2.5ZM18.0884 14.3794C18.0881 14.6145 17.9934 14.8398 17.8249 15.006C17.6564 15.1722 17.428 15.2657 17.1897 15.266H2.81062C2.57235 15.2657 2.34392 15.1722 2.17544 15.006C2.00696 14.8398 1.91219 14.6145 1.91193 14.3794V4.45035C1.91221 4.21532 2.00699 3.98999 2.17546 3.8238C2.34394 3.6576 2.57236 3.56411 2.81062 3.56383H17.1897C17.428 3.56411 17.6564 3.6576 17.8249 3.8238C17.9933 3.98999 18.0881 4.21532 18.0884 4.45035V14.3794Z",
    fill: "#F9B42A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.6667L7.93872 8.41743L11.2908 10.6575L14.1667 7.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.3386 19.0109C13.4398 18.9111 13.4966 18.7758 13.4966 18.6347C13.4966 18.4937 13.4398 18.3584 13.3386 18.2586C13.2375 18.1589 13.1004 18.1028 12.9574 18.1028H7.20572C7.06271 18.1028 6.92556 18.1589 6.82444 18.2586C6.72331 18.3584 6.6665 18.4937 6.6665 18.6347C6.6665 18.7758 6.72331 18.9111 6.82444 19.0109C6.92556 19.1106 7.06271 19.1666 7.20572 19.1666H12.9574C13.1004 19.1666 13.2375 19.1106 13.3386 19.0109Z",
    fill: "#F9B42A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.b6f6b17a.svg";
export { ForwardRef as ReactComponent };